"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var __1 = __importDefault(require(".."));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PriceDescription = function (_a) {
    var _b;
    var sqmPrice = _a.sqmPrice, deposit = _a.deposit, deal = _a.deal, className = _a.className;
    var t = react_i18next_1.useTranslation('common').t;
    var isRent = function () { return deal === GeneralSettings_1.DEAL_TYPES.RENT; };
    if (isRent()) {
        if (!deposit[0].price) {
            return (react_1.default.createElement("span", { className: className },
                "(",
                t('POST_PREVIEW.NO_DEPOSIT'),
                ")"));
        }
        return (react_1.default.createElement("span", { className: className },
            "(",
            react_1.default.createElement(__1.default, { value: deposit, className: styles_module_scss_1.default.price }),
            ' ',
            react_1.default.createElement("span", null, t('POST_PREVIEW.DEPOSIT')),
            ")"));
    }
    if (!((_b = sqmPrice[0]) === null || _b === void 0 ? void 0 : _b.price)) {
        return null;
    }
    if (sqmPrice.length > 1) {
        sqmPrice.sort(function (a, b) {
            return Number(a.price) - Number(b.price);
        });
        var sqmPriceMin = [sqmPrice[0]];
        var sqmPriceMax = [sqmPrice[sqmPrice.length - 1]];
        return (react_1.default.createElement("span", { className: className },
            "(",
            react_1.default.createElement(__1.default, { value: sqmPriceMin, className: styles_module_scss_1.default.price }),
            ' ',
            react_1.default.createElement("span", null, t('POST_PREVIEW.SQM')),
            '-',
            react_1.default.createElement(__1.default, { value: sqmPriceMax, className: styles_module_scss_1.default.price }),
            ' ',
            react_1.default.createElement("span", null, t('POST_PREVIEW.SQM')),
            ")"));
    }
    return (react_1.default.createElement("span", { className: className },
        "(",
        react_1.default.createElement(__1.default, { value: sqmPrice, className: styles_module_scss_1.default.price }),
        ' ',
        react_1.default.createElement("span", null, t('POST_PREVIEW.SQM')),
        ")"));
};
exports.default = PriceDescription;
